import { render, staticRenderFns } from "./DimensionCom.vue?vue&type=template&id=255e5602&scoped=true"
import script from "./DimensionCom.vue?vue&type=script&lang=js"
export * from "./DimensionCom.vue?vue&type=script&lang=js"
import style0 from "./DimensionCom.vue?vue&type=style&index=0&id=255e5602&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255e5602",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255e5602')) {
      api.createRecord('255e5602', component.options)
    } else {
      api.reload('255e5602', component.options)
    }
    module.hot.accept("./DimensionCom.vue?vue&type=template&id=255e5602&scoped=true", function () {
      api.rerender('255e5602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/property-editor/components/DimensionCom.vue"
export default component.exports